'use client';

import SharedLayout from '../components/SharedLayout';
import Link from 'next/link';
import { MotionDiv } from '@/components/motion';
import { FileText, Shield, Leaf, AlertTriangle } from 'lucide-react';

const policies = [
  {
    id: 'calidad',
    title: 'Política de Calidad',
    description: 'Nuestro compromiso con la excelencia en productos y servicios',
    icon: Shield,
    href: '/politicas/calidad',
  },
  {
    id: 'ambiental',
    title: 'Política Ambiental',
    description: 'Cómo minimizamos nuestro impacto en el medio ambiente',
    icon: Leaf,
    href: '/politicas/ambiental',
  },
  {
    id: 'precursores-quimicos',
    title: 'Política de Precursores Químicos',
    description: 'Normativas sobre precursores químicos y política antidrogas en el trabajo',
    icon: AlertTriangle,
    href: '/politicas/precursores-quimicos',
  },
];

export default function PoliciesPage() {
  return (
    <SharedLayout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-center mb-10">Políticas y Normativas</h1>
        
        <div className="max-w-4xl mx-auto">
          <p className="text-lg text-gray-700 text-center mb-12">
            En Droquimar, nos comprometemos con los más altos estándares de calidad, 
            sostenibilidad y ética empresarial. Consulte nuestras políticas corporativas 
            para conocer más sobre nuestros valores y compromisos.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {policies.map((policy, index) => (
              <MotionDiv
                key={policy.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                <Link 
                  href={policy.href}
                  className="block h-full bg-white rounded-lg shadow-lg hover:shadow-xl p-6 transition-shadow duration-300"
                >
                  <div className="flex flex-col h-full">
                    <div className="bg-blue-50 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                      <policy.icon className="h-6 w-6 text-blue-600" />
                    </div>
                    
                    <h2 className="text-xl font-semibold mb-2">{policy.title}</h2>
                    <p className="text-gray-600 flex-grow">{policy.description}</p>
                    
                    <div className="mt-4 pt-4 border-t border-gray-100 text-blue-600 font-medium">
                      Ver más
                    </div>
                  </div>
                </Link>
              </MotionDiv>
            ))}
          </div>
        </div>
      </div>
    </SharedLayout>
  );
} 